export default __webpack_public_path__ + "static/media/tennis-champions-cover.863c3014.png";